export const summaryTableGroupingState = 'summaryTableGroupingState';
